// extracted by mini-css-extract-plugin
module.exports =  {"ribbon":"INg0tB","NoFlexOverlayContainer":"le9PN6","noFlexOverlayContainer":"le9PN6","on-image":"FbHYze","onImage":"FbHYze","product-info":"IPqs5F","productInfo":"IPqs5F"};